import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ITripleEightCasinoIconProps extends ISvgIconProps {

}

export class TripleEightCasinoIcon extends React.Component<ITripleEightCasinoIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5">
                    <path d="M8.514 20.786s-.073-2.348 0-2.372a9.15 9.15 0 0 0 1.4-2.251 8.248 8.248 0 0 0 .817-3.155c.006-.084 0-.088 0-.088a7.56 7.56 0 0 1-1.858-1.4c-1.452-1.283-2.2-3.9-2.42-5.712a14.229 14.229 0 0 1-.146-2.614h5.47" strokeLinejoin="round"/>
                    <path d="M15.208 20.786s.073-2.348 0-2.372a9.14 9.14 0 0 1-1.4-2.251 8.248 8.248 0 0 1-.817-3.155c-.006-.084 0-.088 0-.088a7.547 7.547 0 0 0 1.858-1.4c1.452-1.283 2.2-3.9 2.42-5.712a14.307 14.307 0 0 0 .145-2.614h-5.47" strokeLinejoin="round"/>
                    <path d="M7.577 20.787h8.621"/>
                    <path d="M8.75 18.554h6.275"/>
                    <path d="M6.22 4.303H3.354s-.43-.053-.417.325A5.377 5.377 0 0 0 4.25 9.001a5.583 5.583 0 0 0 3.91 1.785" strokeLinejoin="round"/>
                    <path d="M17.78 4.303h2.869s.43-.053.417.325a5.375 5.375 0 0 1-1.315 4.373 5.582 5.582 0 0 1-3.911 1.785" strokeLinejoin="round"/>
                </g>
            </SvgIcon>
        );
    }
}
